export const CERTIFICATE_TYPE_ID = 'tutor_certificate_type_id';
export const CERTIFICATE_FILE = 'tutor_certificate';



// WEBPACK FOOTER //
// ./app/constants/tutorCertificateFields.js